import * as React from "react"

const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m8.9 4.6-.4-.3-.7.7.3.4 2.2 2.1H3v1h7.3L8 10.6l-.3.4.7.7.4-.3 3-3 .3-.4-.3-.4-3-3Z" />
  </svg>
)

export default ArrowRight
